import { ListScaffold, type ListRow } from "@/components/ListScaffold";

// Policies (presentational scaffolding). Mirrors the Submissions tab; not wired.
const ROWS: ListRow[] = [
  {
    id: "POL-5521",
    account: "Acme Builders LLC",
    coverage: "General Liability",
    date: "2026-01-01",
    status: "active",
    carrier: "Travelers",
  },
  {
    id: "POL-5522",
    account: "Ironwood Construction",
    coverage: "Workers Compensation",
    date: "2025-11-15",
    status: "active",
    carrier: "Pie",
  },
  {
    id: "POL-5523",
    account: "Harbor Freight Co",
    coverage: "Commercial Auto",
    date: "2026-02-01",
    status: "active",
    carrier: "Progressive",
  },
  {
    id: "POL-5524",
    account: "Summit Point Contractors",
    coverage: "Builders Risk",
    date: "2025-09-01",
    status: "expired",
    carrier: "Chubb",
  },
];

export function PoliciesPage() {
  return (
    <ListScaffold
      title="Policies"
      subtitle="Active and expired policies across your book."
      idLabel="Policy"
      dateLabel="Effective"
      noun="policies"
      rows={ROWS}
    />
  );
}
